const comments = [
  {
    name: '吃瓜小能手',
    avatar: '🍉',
    time: '3小时前',
    content: '这个瓜我追了一整天了，信息量太大了！每一条新进展都让人目瞪口呆，建议大家都去看看原视频。',
    likes: '2.3k',
  },
  {
    name: '娱乐圈观察员',
    avatar: '🔍',
    time: '5小时前',
    content: '作为一个追星十年的老粉，这次事件的走向完全出乎意料。只能说贵圈真乱，但51吃瓜的整理真的很到位。',
    likes: '1.8k',
  },
  {
    name: '今日份吃瓜',
    avatar: '😋',
    time: '8小时前',
    content: '每天刷51吃瓜已经成了习惯，比刷微博还有意思。视频合集整理得特别清楚，省得我一个一个去找了。',
    likes: '1.5k',
  },
  {
    name: '路人甲路过',
    avatar: '👀',
    time: '12小时前',
    content: '本来对娱乐圈不感兴趣，被朋友推荐来看的，结果一看就停不下来了。这瓜保熟，推荐给所有吃瓜群众！',
    likes: '986',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            💬 瓜友热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            看看其他瓜友怎么说，一起加入讨论
          </p>
        </div>

        <div className="space-y-4">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 transition-colors duration-200 hover:border-primary-200/50"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-lg flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-bold text-foreground-900">{item.name}</span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-heart-line"></i>
                  {item.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-share-forward-line"></i>
                  分享
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}